import { resolveMediaUrl } from './mediaHelpers';

export const mapTeamMember = (member) => ({
  id: member.documentId,
  name: member.name,
  role: member.role,
  photo: resolveMediaUrl(member.photo),
});
